import { FC, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { DataTable } from "src/features/reporting/components";
import { useAreaReport } from "src/features/reporting/hooks";

interface Props {
	formId: number;
	year: number;
	regionId: number;
	showCompliantReport?: boolean;
	showObservationsPassedThresholdReport?: boolean;
	observationType: IObservationType;
	calendarMonth?: Month;
	calendarYear?: number;
	onDownloadReady?: (downloadFn: () => void) => void;
}

const MonthlyAreaReport: FC<Props> = ({
	formId,
	year,
	regionId,
	observationType,
	showCompliantReport,
	showObservationsPassedThresholdReport,
	calendarMonth,
	calendarYear,
	onDownloadReady
}) => {
	const { setValue } = useFormContext<ReportDetailForm>();

	const { columns, data, isSuccess, isLoading, download } = useAreaReport({
		year,
		formId,
		regionId,
		compliancy: showCompliantReport,
		threshold: showObservationsPassedThresholdReport,
		observationType
	});

	useEffect(() => {
		if (download && onDownloadReady) {
			onDownloadReady(download);
		}
	}, [download, onDownloadReady]);

	return (
		<>
			{isLoading && (
				<div className="flex justify-center items-center py-12">
					<div className="w-5 h-5 border-2 border-border border-t-primary rounded-full animate-spin" />
				</div>
			)}
			{isSuccess && (
				<DataTable
					columns={columns}
					data={data}
					calendarMonth={calendarMonth}
					observationType={observationType}
					calendarYear={calendarYear}
					emptyDataMessage="No area data found"
					onRowClick={(row: any) => setValue("filters.areaId", row.areaId)}
				/>
			)}
		</>
	);
};

export default MonthlyAreaReport;
